"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.remove = remove;
exports.has = has;
exports.all = all;
exports.clear = clear;
var types = {};

function add(name) {
  types[name] = true;
}

function remove(name) {
  types[name] = false;
}

function has(name) {
  return !!types[name];
}

function all() {
  return Object.keys(types).filter(has);
}

function clear() {
  all().forEach(remove);
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/redux-act/lib/types.js
 ** module id = 721
 ** module chunks = 3
 **/